import { COMMON_ADD_PRESUPUESTO_ULTIMO_EDITADO } from './constants';

const subMenuUltimoEditado = {
  name :'Último editado',
  slug :'presupuestador/ultimo-editado',
  icon :null,
  initials :"UED",
  order :1,
  disabled :false,
};

const PRESUPUESTADOR = 'Presupuestador';

export function addMenuPresupuestoUltimoEditado() {
  return (dispatch, getState) => {
    const { common: { user: { system } }} = getState();

    const newSystem = system.map(menuItem => {
      if(menuItem.name === PRESUPUESTADOR) {
        menuItem.content.push(subMenuUltimoEditado) 
      }
      return menuItem
    })
  
    dispatch({
      type: COMMON_ADD_PRESUPUESTO_ULTIMO_EDITADO,
      data: newSystem,
    })

  }
}

export function reducer(state, action) {
  if (action.type === COMMON_ADD_PRESUPUESTO_ULTIMO_EDITADO) {
      return {
        ...state,
        user: {
          ...state.user,
          system: action.data
        }
      }
  }
  else{
    return state
  }
}